import { ClassificationInfoPayload } from "../../classification-search-store/models/classification-unit";

export class Eligibility {
    constructor() {    }
    eligibilityResponseSet1: EligibilityResponseSet1;
    eligibilityResponseSet5: EligibilityResponseSet5;
    eligibilityResponseWorkerSubcontractor: EligibilityResponseWorkerSubcontractor;
}

export class EligibilityResponseSet1 {
    constructor() {    }
    accountRevivalIndicator?: any;
    businessNumber?: any;
    currentWorkerIndicator?: any;
    workerStartDate?: any;
    workerEndDate?: any;
    opStartDate: any;
    registeredWorkerCount: number;
    questionTypeCount?: any;
    publiclyTradedIndicator?: any;
    movieTVProductionIndicator?: any;
    businessNumberActionCode?: any;
    businessNumberReasonCode?: any;
    businessNumberReasonTypeCode?: any;
    defaultWorkerStartDateIndicator?: any;
    defaultOPStartDateIndicator?: any;
    workerFirstName?: any;
    workerMiddleName?: any;
    workerLastName?: any;
    workerisaSpouseIndicator?: any;
    workerSpouseDutyText?: any;
    partnerCount?: any;
    activeShareHolderCount?: any;
    userComment?: any;
}

export class EligibilityResponseSet5 {
    constructor() {    }
    previousAccountNumber: string;
    previousAccountName: string;
}

export class EligibilityResponseWorkerSubcontractor {
    constructor() {    }
    subcontractorHiringIndicator?: string;
    subcontractorHiringText?: string;
    subcontractorFirmIndicator?: string;
    subcontractorFirmText?: string;
    subcontractorGeneralPublicIndicator: string;
    multipleContractsIndicator?: string;
    employmentTypeText?: string;
    hoursEmploymentText?: string;
    workerStatusDescriptionText?: string;
}

export class EligibilityResponseBusinessOperation {
    truckingCourierServiceIndicator: string;
    truckingCourierServiceText: string;
    truckingOtherProvinceIndicator: string;
    businessVehicleDescriptionText: string;
    vehicleOwnershipDescriptionText: string;
    vehicleLeasingFirmName: string;
    productsServicesDescriptionText: string;
    topCompetitorsName: string;
    workLocationText: string;
    otherProvinceIndicator: string;
    servicesPaidDescriptionText: string;
    advertiseServicesIndicator: string;
    advertisingMethodsDescriptionText: string;
}

export class EligibilityE2E {
    eligibilityResponseSet1: EligibilityResponseSet1;
    eligibilityResponseSet5: EligibilityResponseSet5;    
    eligibilityResponseBusinessOperation: EligibilityResponseBusinessOperation;
}

export class CorporationInfo {	
	legalName: string;
	legalNameConfirm: string;
	tradeName?: string;
	incorporationNumber?: string;
	incorporationDate: string;
	incorporationJurisdictionCode?: string;
	incorporationProvinceCode?: string;	
	
    businessNumber: string;
	opStartDate: string;	

    phoneAreaCode: string;
	phoneNumber: string;
    phoneExtension: string;
    phoneAreaCode2?: string;
	phoneNumber2?: string;
    phoneExtension2?: string;
    websiteAddress?: string; 
}

export class JurisdictionInBC
{   
    hasPreviousAccount?: string;
	previousAccountName?: string;
    previousAccountNumber?: string;
    employWorkers?: string;
    registeredWorkerCount?: number;
	workerStartDate?: string;
}


export class JurisdictionOutOfBC
{
    hasPreviousAccount?: string;
	previousAccountName?: string;
	previousAccountNumber?: string;
    employWorkersInBC?: string;
    workerCountInBC?: number; 
    workerStartDateInBC?: string; 
    outOfProvinceCoverage?: string; 
    outOfProvinceBCWorkDays?: string;
    outOfProvinceBCTrips?: string;
}

export class AddressDetailsPayload { 
  streetLine1?: string;
  streetLine2?: string;
  city?: string;
  provinceCode?: string;
  postalCode?: string;
  country?: string;         
  locationTypeCode?: string;
  addressTypeCode?: string;
  isSamePhysicalAddress?: boolean;
  canadaPostValidateCode?: string;
}


export class BusinessDetailsInfoPayload {  
	corporationInfo?: CorporationInfo;
    jurisdictionInBC?: JurisdictionInBC;
    jurisdictionOutOfBC?: JurisdictionOutOfBC;
	mailingAddress?: AddressDetailsPayload;
	workAddress?: AddressDetailsPayload;	 
}

//SolePropBusinessDetailsInfoPayload
export class AnotherPreviousAccountInfo{
    previousAccountNumber?: string;
    previousAccountName?: string;
}

export class OtherAccountInfo{
    accountName?: string;
    accountNumber?: string;
    relationship?: string;
}

export class EquipmentInfo{
    descriptionMajorEquipment?: string;
    makeModel?: string;
    ownLeaseRent?: string;
} 

export class BusinessBackgroundInfo {		
    firmType?: string;
    businessNumber?: string;    
    hasGivenT4ToOther?: string;
    hasSocialInsuranceNumber?: string;
    hasPreviousAccount?: string;
    previousAccountNumber?: string;
    previousAccountName?: string;
    anotherPreviousAccountInfo?: AnotherPreviousAccountInfo[];
    hasOtherBusinessInBC?: string;
    otherAccounts?: OtherAccountInfo[];  
    isHomesharingProvider?: string;   
    hasMultipleClients?: string;
    whoAreYouProvideProductsServices?: string;
    whoElseAreYouProvideProductsServices?: string;
    clientName?: string;
    hasWorkEndDate?: string;
    isLookingForOtherClients?: string;
    hasOwnWorkSchedule?: string;
    yourElseWorkSchedule?: string;
    canDeclineWork?: string;
    hasNegotiatePayment?: string;
    hasCarryLiabilityInsurance?: string;
    workingDays?: string; 
    areYouContractedWithCommunityLinvingBC?: string;
    contractedAgentName?: string;
    areYouSupportDisableAdultsInYourOwnHome?: string;
    numberOfAdultsInYourCare?: string;
    doYouControlOperationAndFunsSpent?: string;
}

export class RevenueExpenses {		
    hasMajorEquipment?: string; 
    equipments?: EquipmentInfo[]; 
    hasRentLeaseEquipment?: string; 
    hasProvideMajorMaterials?: string; 
    materials?: string[]; 
    hasResponsibleForAdditionalCosts?: string; 
    otherBusinessExpensesTypes?: string; 
    otherBusinessExpenses?: string; 
    advertisingMethods?: string;
    howElseClientsFindYou?: string; 
    websiteAddress?: string;
}

export class WorkerInfo {  
    hasContractorsOrSubcontractors?: string; 
    numberOfWorkers?: string; 
    workerFirstName?: string; 
    workerMiddleName?: string; 
    workerLastName?: string; 
    firstWorkerStartDate?: string; 
}

export class SolePropBusinessDetailsInfoPayload {  
    pageId?: string
    businessBackgroundInfo?: BusinessBackgroundInfo;
    revenueExpenses?: RevenueExpenses;
    workerInfo?: WorkerInfo;	
    classificationInfoPageSoleProp?: ClassificationInfoPayload;
}


//  HomeownerBusinessDetailsInfoPayload
export class BusinessDetailsInfoHomeOwner {	
    hasPreviousAccount?: string;
    previousAccountNumber?: string;
    previousAccountName?: string;
    numberOfWorkers?: string;
    workerStatusDescriptionText?: string;
    employmentTypeText?: string;
    hoursEmploymentText?: string;
    firstWorkerStartDate?: string;
    workEndDate?: string;
    summaryOfWork?: string;
}

export class HomeOwnerBusinessDetailsInfoPayload {  
    pageId?: string
    businessDetailsInfo?: BusinessDetailsInfoHomeOwner;  
}
